export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.7d6edc8c901001f18ab2ebe63c2af69f.css";